<section class="iq-contact-frame pt-0">
    <div class="container">
        <div class="row">
            <!-- <div class="col-lg-6 col-md-12">
                <iframe src="https://maps.google.com/maps?q=London%20Eye%2C%20London%2C%20United%20Kingdom&amp;t=m&amp;z=10&amp;output=embed&amp;iwloc=near" aria-label="London Eye, London, United Kingdom"></iframe>
            </div> -->
            <div class="col-lg-6 col-md-12 mt-5 mt-lg-0">                
                <app-title-section [titleSectionProp]="titleSectionProp"></app-title-section>
                <div role="form" class="wpcf7">
                    <form class="wpcf7-form">
                        <div class=row>
                            <div class="col-lg-6">
                                <span class="wpcf7-form-control-wrap server-name">
                                    <input type="text" name="server-name" value="" size="40" class="wpcf7-form-control wpcf7-text wpcf7-validates-as-required" placeholder="Name of the Server" />
                                </span>
                            </div>
                            <!-- <div class="col-lg-6">
                                <span class="wpcf7-form-control-wrap last-name">
                                    <input type="text" name="last-name" value="" size="40" class="wpcf7-form-control wpcf7-text wpcf7-validates-as-required" placeholder="Last Name" />
                                </span>
                            </div> -->
                            <div class="col-lg-6">
                                <span class="wpcf7-form-control-wrap your-email">
                                    <input type="email" name="your-email" value="" size="40" class="wpcf7-form-control wpcf7-text wpcf7-email wpcf7-validates-as-required wpcf7-validates-as-email" placeholder="Email Address" />
                                </span>
                            </div>
                            <div class="col-lg-6">
                                <span class="wpcf7-form-control-wrap tel-554">
                                    <input type="tel" name="tel-554" value="" size="40" class="wpcf7-form-control wpcf7-text wpcf7-tel wpcf7-validates-as-tel" placeholder="Phone" />
                                </span>
                            </div>
                            <div class="col-lg-12">
                                <p>
                                    <span class="wpcf7-form-control-wrap issue">
                                        <textarea name="issue" cols="40" rows="10" class="wpcf7-form-control wpcf7-textarea" placeholder="Write your Issue"></textarea>
                                    </span>
                                </p>
                            </div>
                            <div class="col-lg-12">
                                <input type="submit" value="Send" class="wpcf7-form-control wpcf7-submit" />
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</section>